import { render, staticRenderFns } from "./course.vue?vue&type=template&id=4f5e44b4&scoped=true"
import script from "./course.vue?vue&type=script&lang=ts"
export * from "./course.vue?vue&type=script&lang=ts"
import style0 from "./course.vue?vue&type=style&index=0&id=4f5e44b4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5e44b4",
  null
  
)

export default component.exports